import SearchieClient from './SearchieClient';

if ( !window.Searchie ) window.Searchie = {};

(function (w, d, {team, user}) {

  window.SearchieClient = new SearchieClient(team, user);

})(window, document, window.Searchie);
